<template>
  <div class="business" id="business">
    <div>
      <div class="business-top">
        <h1>{{ $t('business.title') }}</h1>
        <p>{{ $t('business.describe') }}</p>
      </div>

      <div class="business-bot">
        <div class="business-item" v-for="(item, index) in list" :key="index">
          <div class="business-item-top">
            <p>{{ item.titleZh }}</p>
            <p>{{ item.titleEn }}</p>
          </div>
          <div class="business-item-content">
            <div v-for="(ite, indx) in item.list" :key="indx">
              <p>
                <span>
                  {{ ite.title }}
                </span>
                <span>
                  {{ ite.count }}
                </span>
              </p>
              <p>{{ ite.describe }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="img-item">
        <p> <img src="@/assets/left.png" alt=""></p>
        <div v-for="(item, index) in imgeList" :key="index">
          <img :src="item" alt="">
        </div>
        <p> <img src="@/assets/right.png" alt=""></p>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      imgeList: []
    }
  },
  computed: {
    list() {
      return this.$t("business.list")
    },
    imgList() {
      return this.$t('imgList')
    }
  },
  created() {




  },
  methods: {
    require: (imgPath) => {
      try {
        const handlePath = imgPath.replace('@', '..');
        // https://vitejs.cn/guide/assets.html#the-public-directory
        return new URL(handlePath, import.meta.url).href;
      } catch (error) {
        console.warn(error);
      }
    }
  }
}
</script>


<style lang="less" scoped>
.business {
  width: 100%;
  background-color: #fff;

  >div {
    width: 1280px;
    margin: 0 auto;
    padding-top: 60px;
  }

  .business-top {
    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
    }
  }

  .business-bot {
    display: flex;
    // align-items: center;
    border-radius: 8px;
    margin-top: 40px;

    .business-item:not(:nth-of-type(1)) {
      border-left: 1px solid #e7e8ec;
    }

    .business-item {
      width: 426px;
      height: 560px;
      background: #f1f3f8;
    }

    .business-item-top {
      width: 426px;
      height: 260px;
      background-size: cover;
      padding-top: 1px;

      // border-right: 1px solid #fff;
      >p:nth-child(1) {
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 10px;
        margin-top: 135px;
        margin-left: 30px;
      }

      p:nth-child(2) {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 30px;
      }
    }

    .business-item:nth-of-type(1) {
      .business-item-top {
        background-image: url("@/assets/business1.png");
      }
    }

    .business-item:nth-of-type(2) {
      .business-item-top {
        background-image: url("@/assets/business2.png");
      }
    }

    .business-item:nth-of-type(3) {
      .business-item-top {
        background-image: url("@/assets/business3.png");
      }
    }

    .business-item-content {
      height: 300px;
      padding: 40px 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      // justify-content: space-between;
      div:nth-child(1) {
        height: 110px;
        // margin: 40px 0;
      }

      p:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #000000;
        margin-bottom: 10px;

        span:nth-child(2) {
          color: #dfe1e6;
        }
      }

      p {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #616364;
      }
    }
  }

  .img-item {
    display: flex;
    margin-top: 33px;
    width: 1280px;
    height: 260px;
    position: relative;

    img {
      width: 312px;
      height: 260px;
      border-radius: 10px;
    }

    div {
      height: 260px;
    }

    div:not(:nth-child(1)) {
      margin-right: 10px;
    }

    >p {
      width: 50px;

      height: 260px;
      background-color: rgba(179, 193, 212, 0.2);
      position: absolute;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0px;
      right: 0;
      opacity: 0;

      img {
        width: 42px;
        height: 42px;
        border: 1px solid #333333;
        border-radius: 50%;
        cursor: pointer;
      }

    }

    p:hover {
      opacity: 1;

    }

    p:nth-child(1) {
      position: absolute;
      top: 0px;
      left: 0;

      img {

        // position: absolute;
        // top: 102px;
        // left: 0;
      }
    }

  }
}

@media screen and (max-width: 1080px) {
  .business {
    width: 108rem;
    background-color: #fff;
    padding: 5rem;
    box-sizing: border-box;

    >div {
      width: 100%;
      margin: 0 auto;
      padding-top: 8rem;
    }

    .business-top {
      h1 {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 5.3rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 4.3rem;
      }
    }

    .business-bot {
      display: flex;
      flex-direction: column;
      // align-items: center;
      border-radius: 2rem;
      margin-top: 6rem;

      .business-item:not(:nth-of-type(1)) {
        border-left: 1px solid #e7e8ec;
      }

      .business-item {
        width: 98rem;
        height: 98rem;
        background: #f1f3f8;
        margin-bottom: 5rem;
        border-radius: 2rem;
      }

      .business-item-top {
        width: 98rem;
        height: 45rem;
        background-size: cover;
        background-position: center;
        padding-top: 1px;
        border-radius: 2rem 2rem 0 0;

        // border-right: 1px solid #fff;
        >p:nth-child(1) {
          font-size: 5.3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-bottom: 1.5rem;
          margin-top: 23.7rem;
          margin-left: 5rem;
        }

        p:nth-child(2) {
          font-size: 3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 4.3rem;
          margin-left: 5rem;
        }
      }

      .business-item:nth-of-type(1) {
        .business-item-top {
          background-image: url("@/assets/business1.png");
        }
      }

      .business-item:nth-of-type(2) {
        .business-item-top {
          background-image: url("@/assets/business2.png");
        }
      }

      .business-item:nth-of-type(3) {
        .business-item-top {
          background-image: url("@/assets/business3.png");
        }
      }

      .business-item-content {
        height: 54rem;
        padding: 6rem 5rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        border-radius: 0 0 2rem 2rem;

        // justify-content: space-between;
        div:nth-child(1) {
          height: 25rem;
          // margin: 40px 0;
        }

        p:nth-child(1) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 4.5rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin-bottom: 1.3rem;

          span:nth-child(2) {
            color: #dfe1e6;
          }
        }

        p {
          font-size: 3.5rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #616364;
        }
      }
    }

    .img-item {
      display: flex;
      margin-top: 33px;
      width: 1280px;
      height: 260px;
      position: relative;

      img {
        width: 312px;
        height: 260px;
        border-radius: 10px;
      }

      div {
        height: 260px;
      }

      div:not(:nth-child(1)) {
        margin-right: 10px;
      }

      >p {
        width: 50px;

        height: 260px;
        background-color: rgba(179, 193, 212, 0.2);
        position: absolute;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0px;
        right: 0;
        opacity: 0;

        img {
          width: 42px;
          height: 42px;
          border: 1px solid #333333;
          border-radius: 50%;
          cursor: pointer;
        }

      }

      p:hover {
        opacity: 1;

      }

      p:nth-child(1) {
        position: absolute;
        top: 0px;
        left: 0;

        img {

          // position: absolute;
          // top: 102px;
          // left: 0;
        }
      }

    }
  }
}
</style>